var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427321340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M2.15022 1.01628L10.4997 9.33305L8.83312 10.9997L0.567148 2.73365L2.15022 1.01628Z",
    fill: "#B8C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M10.4832 2.65023L2.16651 10.9998L0.499892 9.33319L8.76586 1.06715L10.4832 2.65023Z",
    fill: "#B8C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M6.65506 0.107422L6.67836 11.8923H4.32139L4.32129 0.202384L6.65506 0.107422Z",
    fill: "#B8C5CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/Asterisk.03516c81a62dd5943578af731a01466e.svg";
export { ForwardRef as ReactComponent };